/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of AH5EnvConfigSync
 */

import { IPlugin } from 'com/didichuxing/plugin/IPlugin';
import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { ITracker } from 'com/didichuxing/tracker/ITracker';
import { IEnvConfigurationItemSync } from 'com/didichuxing/tracker/config/IEnvConfigurationItemSync';
import {
    IReportingStrategyPluginConstr
} from 'com/didichuxing/tracker/plugin/IReportingStrategyPlugin';
import GlobalUtil from 'com/didichuxing/tracker/plugin/utils/GlobalUtil';

export default abstract class AH5EnvConfigSync implements IEnvConfigurationItemSync {

    private pluginConstrs: IReportingStrategyPluginConstr[];

    private plugins: IPlugin[] | undefined;

    private tracker: ITracker;

    constructor(tracker: ITracker, pluginConstrs: IReportingStrategyPluginConstr[]) {
        this.pluginConstrs = pluginConstrs;
        this.tracker = tracker;
    }

    /**
     * @abstract
     * @param {ITrackerContext} context
     * @returns {boolean}
     */
    public abstract validate(context: ITrackerContext): boolean;

    /**
     * @abstract
     * @param {ITracker} tracker
     * @returns {Promise<void>}
     */
    public abstract beforeDeliver(tracker: ITracker): Promise<void>;

    /**
     * @override
     * @inheritDoc
     * @returns {IPlugin[]}
     */
    public getPlugins(): IPlugin[] {
        if (!this.plugins) {
            this.plugins = this.pluginConstrs.map<IPlugin>((pluginConstr: IReportingStrategyPluginConstr): IPlugin => {
                return new pluginConstr(this.tracker);
            });
        }
        return this.plugins;
    }

    /**
     * 获取额外插件url。
     * @returns {string}
     */
    public getExtraPluginsUrl(): string {
        let host: string = '{{cdnHost}}';
        let cdnNamespace: string = '{{cdnNamespace}}';
        if (/global/.test((this.tracker.getContext() as ITrackerContext).uploadHost || '')) { // 国际化
            host = '{{cdnGlobalHost}}';
            cdnNamespace = 'tracker_global';
        }
        if (/omgup-ru\.didiglobal\.com/.test((this.tracker.getContext() as ITrackerContext).uploadHost || '')) { // 俄罗斯
            host = '{{cdnDeHost}}';
            cdnNamespace = 'tracker_de';
        }
        if (/omgup-de\.didiglobal\.com/.test((this.tracker.getContext() as ITrackerContext).uploadHost || '')) { // 欧洲
            host = '{{cdnDeHost}}';
            cdnNamespace = 'tracker_de';
        }
        if ((this.tracker.getContext() as ITrackerContext).uploadHost === 'omgup.1meal.net') { // rlab
            host = '{{cdnRlabHost}}';
            cdnNamespace = 'falcon_public/tracker';
        }

        const proto = GlobalUtil.getProtocol();
        return `${ proto }${ host }/static/${ cdnNamespace }/{{version}}/${ this.getExtraPluginsUrlName() }`;
    }

    /**
     * 额外插件url名称。
     * @returns {string}
     */
    protected getExtraPluginsUrlName(): string {
        return 'omega.default.extra.plugins.min.js';
    }
}
